import { call, put, takeLatest, cancelled, all } from "redux-saga/effects"
import axios from "axios"
import { message } from "antd"
import {
  GET_DIVISIONS_AMBASSADOR_WATCHER,
  GET_REPORTS_DASHBOARD_DATA_WATCHER,
} from "./constants"
import {
  getReportsDashboardDataWatcher,
  getReportsDashboardDataSuccess,
  getReportsDashboardDataFailed,
  getAmbassadorDivisionsSuccess,
  getAmbassadorDivisionsFailed,
  getSelectedDivisionSuccess,
} from "./actions"

import { LOCAL_TOKEN, LOCAL_COMPANY_ID } from "utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

function getAmbassadorDivisionApi() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}ambassador/divisions`,
  })
}

function getDashboardDataApi(params) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/dashboard/${LOCAL_COMPANY_ID()}`,
    params,
  })
}

export function* getAmbassadorDivisionsSaga() {
  try {
    const { data, status } = yield call(getAmbassadorDivisionApi)
    if (status === 200) {
      yield put(getAmbassadorDivisionsSuccess(data))
    }
  } catch (e) {
    yield put(getAmbassadorDivisionsFailed(error))
    yield call(
      messageFailed,
      "No se pudo obtener la información del dahsboard."
    )
  }
}

export function* getDashboardDataSaga(action) {
  try {
    const { data, status } = yield call(getDashboardDataApi, action.payload)
    if (status === 200) {
      if (action.payload) {
        yield put(getSelectedDivisionSuccess(action.payload.id_division))
      }
      yield put(getReportsDashboardDataSuccess(data.data))
    }
  } catch (error) {
    yield put(getReportsDashboardDataFailed(error))
    yield call(
      messageFailed,
      "No se pudo obtener la información del dahsboard."
    )
  }
}

export default function* reportsDashboardSaga() {
  yield takeLatest(GET_REPORTS_DASHBOARD_DATA_WATCHER, getDashboardDataSaga)
  yield takeLatest(GET_DIVISIONS_AMBASSADOR_WATCHER, getAmbassadorDivisionsSaga)
}
